import {
    LS_CUSTOMIZATION_KEY,
    LS_CUSTOMIZATION_SET_EVENT_KEY,
    LS_FOOTPRINT_KEY,
    LS_WAITING_TEXT_KEY,
} from "constants/constants";
import { CSS_VARIABLES } from "enums/cssVariables";

export type CustomizationProps = {
    logoAlignment: string;
    titleColor: string;
    titleBackgroundColor: string;
    buttonColor: string;
    buttonBackgroundColor: string;
    logoUrl: string;
    installationButtonDisplay: boolean;
};

const CUSTOMIZATION_PROP_LOGO_URL = "logoUrl";
const CUSTOMIZATION_PROP_LOGO_ALIGNMENT = "logoAlignment";
const CUSTOMIZATION_PROP_BUTTON_BACKGROUND_COLOR = "buttonBackgroundColor";
const CUSTOMIZATION_PROP_BUTTON_COLOR = "buttonColor";
const CUSTOMIZATION_PROP_TITLE_BACKGROUND_COLOR = "titleBackgroundColor";
const CUSTOMIZATION_PROP_TITLE_COLOR = "titleColor";
const CUSTOMIZATION_PROP_INSTALLATION_BUTTON_DISPLAY =
    "installationButtonDisplay";

const customizationPropsToCssVariablesMapping = new Map<string, string>([
    [CUSTOMIZATION_PROP_TITLE_COLOR, CSS_VARIABLES.PRIMARY_TEXT_COLOR],
    [
        CUSTOMIZATION_PROP_TITLE_BACKGROUND_COLOR,
        CSS_VARIABLES.BACKGROUND_FORM_COLOR,
    ],
    [CUSTOMIZATION_PROP_BUTTON_COLOR, CSS_VARIABLES.PRIMARY_BUTTON_TEXT_COLOR],
    [
        CUSTOMIZATION_PROP_BUTTON_BACKGROUND_COLOR,
        CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR,
    ],
    [CUSTOMIZATION_PROP_LOGO_ALIGNMENT, CSS_VARIABLES.LOGO_ALIGNMENT],
    [CUSTOMIZATION_PROP_LOGO_URL, CSS_VARIABLES.LOGO_URL],
    [
        CUSTOMIZATION_PROP_INSTALLATION_BUTTON_DISPLAY,
        CSS_VARIABLES.INSTALLATION_BUTTON_DISPLAY,
    ],
]);

export interface Customization {
    subdomain: string;
    waitingText: string;
    customization: CustomizationProps;
    footprint: string;
}

export interface Subdomain {
    subdomain: string;
    codeOnline: string;
    url: string;
}

export const formatCssVariablesFromCustomization = (
    props: CustomizationProps,
) => {
    if (props.logoUrl) {
        props.logoUrl = `url(${props.logoUrl})`;
    }
    if (props.installationButtonDisplay) {
        props.installationButtonDisplay = "flex" as any;
    }

    return (
        Object.keys(props)
            .filter((field) => props[field as keyof CustomizationProps])
            .map(
                (field) =>
                    `${customizationPropsToCssVariablesMapping.get(field)}: ${
                        props[field as keyof CustomizationProps]
                    }`,
            )
            .join("; ") + "; "
    );
};

export const setCustomizationLocalStorage = (value: string) => {
    localStorage.setItem(LS_CUSTOMIZATION_KEY, value);
    window.dispatchEvent(new Event(LS_CUSTOMIZATION_SET_EVENT_KEY));
};

export const getCustomizationLocalStorage = (): string | null => {
    return localStorage.getItem(LS_CUSTOMIZATION_KEY);
};

export const setWaitingTextLocalStorage = (text: string) =>
    localStorage.setItem(LS_WAITING_TEXT_KEY, text);

export const setFootprintLocalStorage = (footprint: string) =>
    localStorage.setItem(LS_FOOTPRINT_KEY, footprint);

export const saveCustomization = (customization: Customization) => {
    setFootprintLocalStorage(customization.footprint);
    setWaitingTextLocalStorage(customization.waitingText);

    const cssVars = formatCssVariablesFromCustomization(
        customization.customization,
    );

    setCustomizationLocalStorage(cssVars);
};
